import React, { Component } from "react";
import { observer } from "mobx-react";
import { origin_info_item_save } from "http/DetailConn"
import { fn_scroll_down, fn_scroll_up } from "function/FnScroll";
import { fn_initOutPrinter } from "function/FnBodySetting"

@observer
class OriginAddView extends Component {

    constructor(props) {
        super(props);
        this.info = React.createRef();
    }

    render() {
        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;

        return (
            <div className={"layer_comm layer_common_type " + (layerStore.getLayerOriginView ? ' layer_open' : '')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section add">
                            <div className="info">
                                <div className="top">
                                    <span className="top_txt">원산지 설정</span>
                                </div>
                                <div className="content">
                                    <div className="box_txt">
                                        <div className="inner">
                                            <div className="scroll scroll_hidden" id="boxScroll" ref={this.info}>
                                                <h4>원산지 표기법</h4>
                                                <p className="notice">작성방법을 잘 숙지해서 기입해주세요</p>
                                                <ul className="list" >
                                                    <li className="tit"><strong>·</strong>원산지 정보는 ‘메뉴별’로 표시하세요
                                                        <ul className="txt">
                                                            <li>- 프라이드 치킨 - 닭고기 : 멕시코산</li>
                                                            <li>- 불고기피자 - 돼지고기 : 캐나다산과 미국산 섞음</li>
                                                            <li>- 배추김치 - 배추 : 국내산, 고춧가루 : 중국산</li>
                                                        </ul>
                                                    </li>
                                                    <li className="tit"><strong>·</strong>모든 음식에 사용하는 식자재 원산지가 같을 경우
                                                        <p>일괄 표시할 수 있습니다</p>
                                                        <ul className="txt">
                                                            <li>- 우리 가게에선 국내산 쌀만 사용합니다</li>
                                                            <li>- 우리 업소에서는 중국산 오징어, 꽃게만을 사용합니다</li>
                                                        </ul>
                                                    </li>
                                                    <li className="tit"><strong>·</strong>원산지가 다른 식자재를 사용했을 경우 섞음 비율
                                                        <p>이 높은 순서대로 표시합니다</p>
                                                        <ul className="txt">
                                                            <li>- 호주산 70%, 국내산 30% 쇠고기를 사용한다면</li>
                                                            <li className="br">불고기(쇠고기 : 호주산과 국내산을 섞음)</li>
                                                        </ul>
                                                    </li>
                                                    <li className="tit"><strong>·</strong>표시 대상 품목이 혼합된 경우 각각의 원산지를
                                                        <p>표시하세요</p>
                                                        <ul className="txt">
                                                            <li>- 순두부찌개 - 콩 : 국내산, 오징어 : 중국산, 꽃게 : 중국</li>
                                                            <li>- 쇠고기김밥 - 쇠고기 : 캐나다산, 쌀 : 미국산</li>
                                                        </ul>
                                                    </li>
                                                    <li className="tit"><strong>·</strong>음식점의 경우 아래 식자재 원산지 정보를 반드시
                                                        <p>표기해야 합니다.(총 24품목)</p>
                                                        <ul className="txt">
                                                            <li>- 농축산물(9개) : 쇠고기, 돼지고기, 닭고기, 오리고기, 양고기, 염소고기(유산양 포함), 배추김치, 쌀(밥, 죽, 누룽지), 콩(두부류, 콩국수,콩비지)</li>
                                                            <li>- 수산물(15개) : 넙치, 조피볼락, 참돔, 미꾸라지, 뱀장어, 낙지, 고등어, 갈치, 멍태(황태, 복어 등 건조한 것은 제외), 참조기, 오징어, 꽃게, 다랑어, 아귀, 쭈꾸미 이외 수족관에 살아있는 모든 수산물</li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="btnsCol">
                                            <button type="button" className={(rootStore.layerStore.getScrollDisabled.up) ? "btn_up disabled" : "btn_up"} onClick={event => fn_scroll_up(this.info, "origin", rootStore)}><span></span></button>
                                            <button type="button" className={(rootStore.layerStore.getScrollDisabled.down) ? "btn_down disabled" : "btn_down"} onClick={event => fn_scroll_down(this.info, "origin", rootStore)}><span></span></button>
                                        </div>
                                    </div>
                                    <div className="box_textarea">
                                        <textarea id="originTxt" ref={this.inputFocus} value={rootStore.settingStore.getOriginSettingInfo.originInfo} 
                                            placeholder="판매상품의 원산지를 입력하세요.&#10;입력된 원산지가 있을 경우, 주문전표에 출력&#10;됩니다." 
                                            maxLength={5000}
                                            onChange={event => rootStore.settingStore.setOriginSettingInfo("originInfo", event.target.value)}
                                        >
                                        </textarea>
                                        <button type="button" className="btn" onClick={() => { origin_info_item_save(rootStore); fn_initOutPrinter(rootStore) }}>설정</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="btn_close">
                            <button
                                onClick={event => { fn_initOutPrinter(rootStore) }}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default OriginAddView;